import React from 'react';

import Background from './Home/back.jpg';
import Home from './Home/Home';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Slide from '@material-ui/core/Slide';
import Seminars from './Seminars/Seminars';
import Members from './Members/Members';
import Research from './Research/Research.js';
import Positions from './Positions/Positions';
import {
  HashRouter,
  Route,
  Switch,
  Link as RouterLink
} from "react-router-dom";


const styleFirstPage =
  {
    flexGrow: 1,
    minHeight:'100vh',
    minWdith:'100vw',
    backgroundImage: "url(" +  Background  + ")",
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    color: '#6a737b',
    fontFamily: 'Arial'  
};


const styleOtherPages =
  {
    flexGrow: 1,
    width: '100vw',
    alignItems: 'center',
    minHeight:'100vh',
    minWdith:'100vw',
    color: '#6a737b',
    backgroundColor: '#E6EBE9',
    fontFamily: 'Arial',
    fontSize: '25px'
  };


  const AppbarStyleFirst = {
    background: 'transparent', 
    color: 'white',
    position: 'fixed',
    top: 0,
    elevation: '10'
}

const AppbarStyleOther = {
  background:  '#009688',
  color: 'white',
  align: 'left',
  position: 'fixed',
  top: 0,
  elevation: '10',
}



function App() {
 
  const routes = ["/", "/members","/research","/seminar","/positions"];
  return (
  
    <div className="App">
      <HashRouter>

      <Route
      path="/"
      render={(history) => (
        <div  style={ (history.location.pathname  === routes[0])?  styleFirstPage  :  styleOtherPages}>
        <AppBar style={ (history.location.pathname  === routes[0]) ?  AppbarStyleFirst  :  AppbarStyleOther}
       >
          <Tabs 
          value={
            history.location.pathname !== "/RMSMA"
              ? history.location.pathname
              : false
          }   
          centered       
          indicatorColor="primary"
          textColor="inherit"
          backgroundColor="secondary"   
          >      
           <Tab
                  label="Home"
                  value={routes[0]}
                  component={RouterLink}
                  to={routes[0]}
                />     
          <Tab
                  label="Members"
                  value={routes[1]}
                  component={RouterLink}
                  to={routes[1]}
                />
                <Tab
                  label="Research"
                  value={routes[2]}
                  component={RouterLink}
                  to={routes[2]}
                />
                 <Tab
                  label="Seminar"
                  value={routes[3]}
                  component={RouterLink}
                  to={routes[3]}
                />
                 <Tab
                  label="Positions"
                  value={routes[4]}
                  component={RouterLink}
                  to={routes[4]}
                />
        </Tabs>
        </AppBar>
        <Slide direction="left" in={true} mountOnEnter unmountOnExit >
    <div align="center" component="div"  style={{ width: '90%',  padding: 8 * 3}}>
    <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/members" component={Members} />
          <Route path="/research" component={Research} />
          <Route path="/seminar" component={Seminars} />
          <Route path="/positions" component={Positions} />
          </Switch>
    </div>
    </Slide>
        </div>
        )}
        ></Route>
        

        
      </HashRouter>
     
      </div>
  );
}

export default App;
